import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex--align-center flex--gap-medium mb-32" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h5 h5--mb-4" }, " Project deliverables ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: {
				name: 'projects__project__add-scope',
				params: {
					project_id: $props.project.id
				}
			},
        class: "button button--fill button--small",
        disabled: true
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Add scope ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ]),
    _createVNode($setup["ProjectScopeGridComponent"], { project: $props.project }, null, 8 /* PROPS */, ["project"])
  ], 64 /* STABLE_FRAGMENT */))
}